import useUserPreference from "./useUserPreference";

/**
 * Server-side "Seneste placeringer": the SharePoint sites the user picked
 * recently (see api/user/preferences/recent-sharepoint-sites). Reads only run
 * while `enabled` (the chooser is open). Remembering happens in
 * SharePointProvider once a site picker has actually opened.
 */
export const useRecentCloudLocations = (enabled: boolean) => {
  const { useQueryRecentSharePointSites } = useUserPreference();
  const query = useQueryRecentSharePointSites(enabled);

  return { sites: query.data?.sites ?? [] };
};
